import React from "react";
import img from "./assets/TERENCE.jpg";
import RecommendationCard from "./RcommendationCard";

import { quotes } from "./RecommendationData";
import { motion } from "framer-motion";
import RecomCard from "./RecomCard";

const Recommendation = () => {
  //const [selectedId, setSelectedId] = useState(null);

  return (
    <div
      className="h-full   bg-secondary-background-color"
      id="appreciation"
    >
      <div className="flex justify-center mb-6">
        <motion.h3 animate={{ rotate: 360 }} className="section title">
          APPRECIATION
        </motion.h3>
      </div>
      {/* <div className="projects  pb-20 lg:pb-0 flex gap-2 w-full flex-wrap justify-center ">
        {quotes.map((quote) => (
          <RecommendationCard
            img={quote.avatar || img}
            quote={quote.quote}
            name={quote.name}
            url={quote.url}
            role={quote.role}
            alt="userAvater"
            key={quote.id}
            username={quote.username}
          />
        ))}
      </div> */}
      <div className="flex justify-center flex-wrap p-8 lg:p-0 gap-2">
        {quotes.map((quote) => (
          <RecomCard
            img={quote.avatar || img}
            quote={quote.quote}
            name={quote.name}
            url={quote.url}
            role={quote.role}
            alt="userAvater"
            key={quote.id}
            username={quote.username}
          />
        ))}
      </div>
    </div>
  );
};

export default Recommendation;
